<template>
    <div class="futuristic-loader-container">
        <div class="futuristic-loader">
            <div class="loader-content">
                <div class="percentage">{{ displayPercentage }}%</div>
                <div class="progress-bar">
                    <div class="progress-fill" :style="{ width: `${progress}%` }"></div>
                </div>
                <div class="loader-text">{{ text }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FuturisticLoaderComponent',
    props: {
        progress: {
            type: Number,
            required: true
        },
        text: {
            type: String,
            default: 'Loading...'
        }
    },
    computed: {
        displayPercentage() {
            return Math.floor(this.progress);
        }
    }
}
</script> 